var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Sidebar'),_c('v-main',[_c('v-container',{attrs:{"fluid":_vm.$vuetify.breakpoint.width <= 1920}},[_c('router-view')],1)],1),_c('BottomNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }